// This module checks the health of each individual hosting service extension
// There has been some debate over whether this is necessary, as the client side check to AFD
// should be enough to signal overall health, so this check is hidden from the client UI
// and information is able to be viewed from downloadable diagnostics BLOB.
import { pingEndpoints, getRequest } from "../Helpers/AjaxHelper";
import { endTest, formatHostingServiceEndpoints } from "../Helpers/EndpointHelper";
import { updateBlob } from "../Helpers/BlobHelper";
import { cancel, isLocal } from "../Helpers/ExecutionStatus";
const global = window;
const { selfHelp: { resources, hostingServiceConfiguration, thirdPartyHostingServiceConfiguration } } = global;
const key = "hostingService";
const hubsExtensionName = "HubsExtension";
// extension manifest data from calling /api/diagnostics
let extensionManifestData;
// the endpoint array constructed from calling /api/diagnostics used to retreive hosting service server health responses
const hostingServiceEndpoints = [];
// the response array with data from each of the endpoints
let hostingServiceResponses = [];
let diagnostics;
/** Ends tests. Updates DOM and Blob. Ensures that if tests have been canceled execution stops. */
function finishTest() {
    if (cancel) {
        return;
    }
    if (diagnostics.success === false) {
        // API Diagnostics failed or hosting service configurations were not retreived from server
        updateBlob(key, diagnostics);
    }
    else {
        endTest(key, hostingServiceResponses);
    }
}
/** pings all hosting service extension endpoints and assigns the responses */
function pingAllHostingService() {
    if (cancel) {
        return;
    }
    if (!hostingServiceEndpoints) {
        diagnostics = {
            success: false,
            details: resources.Endpoints_noEndpointsAvailable,
        };
        finishTest();
        return;
    }
    pingEndpoints(hostingServiceEndpoints, true)
        .then((responses) => {
        hostingServiceResponses = responses;
        finishTest();
    })
        .catch(() => {
        diagnostics = {
            success: false,
            details: resources.HostingService_unknownError,
        };
        finishTest();
    });
}
/**
 * Constructs a hosting service uri and endpiont object out of extension manifest data
 */
function constructExtensionEndpoints() {
    Object.keys(extensionManifestData).forEach((extensionName) => {
        const extension = extensionManifestData[extensionName];
        if (extensionName === hubsExtensionName || !extension.hostingServiceName) {
            // Hubs is hosted by Portal, no need to check
            // If no hostingServiceName, extensions use self host mechanism that should be bypassed
            return;
        }
        const thirdParty = extension.icm && extension.icm.team === "Third Party Extensions";
        const name = extension.icm ? extension.icm.service : extensionName;
        const configStringArray = thirdParty ? thirdPartyHostingServiceConfiguration : hostingServiceConfiguration;
        configStringArray.forEach(configString => {
            const uri = formatHostingServiceEndpoints(configString, extension.hostingServiceName).toString();
            const endpointInfo = { name, extensionName, uri };
            if (extension.primaryStampVersion) {
                endpointInfo.version = extension.primaryStampVersion[0];
            }
            hostingServiceEndpoints.push(endpointInfo);
        });
    });
}
/**
 * Grabs and returns extension manifest from /api/diagnostics for given domain
 *
 * @returns {Promise<void>} assigns response to extensionManifestData
 */
function fetchExtensionData() {
    if (!extensionManifestData) {
        return getRequest("./api/diagnostics")
            .then((res) => {
            const response = JSON.parse(res.response);
            extensionManifestData = response.cachedManifests.manifestState.extensions;
        });
    }
    else {
        return extensionManifestData;
    }
}
/**
 * Ensures we have required information to run diagnostics
 */
function gatherRequiredData() {
    if (cancel) {
        return;
    }
    // Need hosting service configuration in live environments in order to perform diagnostics
    if (!isLocal && (!hostingServiceConfiguration || !thirdPartyHostingServiceConfiguration)) {
        diagnostics = {
            success: false,
            details: resources.HostingService_stringConfigError,
        };
        finishTest();
        return;
    }
    extensionManifestData = fetchExtensionData();
    if (!extensionManifestData) {
        diagnostics = {
            success: false,
            details: resources.Manifest_failure,
        };
        finishTest();
        return;
    }
    constructExtensionEndpoints();
}
/**
 * Triggers beginning of test and update of DOM.
 *
 * @param {boolean} isLocal whether tests are being ran in local environment or not
 */
export function startTest() {
    diagnostics = { success: null, details: null };
    updateBlob(key, { success: null, details: resources.HostingService_inProgress });
    gatherRequiredData();
    pingAllHostingService();
}
//# sourceMappingURL=HostingServiceDiagnostics.js.map